import Cookies from 'js-cookie';

import { shareDomain, shareDomainLijianlifu } from '@/settings';

const TokenKey = 'lj_token';
const expire = 24 * 60 * 60 * 1000 * 1000;

export default {
  setToken(token) {
    var inFifteenMinutes = new Date(new Date().getTime() + expire);
    return Cookies.set(TokenKey, token, { domain: shareDomain, expires: inFifteenMinutes, sameSite: 'lax' });
  },
  getToken() {
    return Cookies.get(TokenKey);
  },
  removeToken() {
    return Cookies.remove(TokenKey, { domain: shareDomain });
  },

  setTokenLijianlifu(token) {
    var inFifteenMinutes = new Date(new Date().getTime() + expire);
    return Cookies.set(TokenKey, token, { domain: shareDomainLijianlifu, expires: inFifteenMinutes, sameSite: 'lax' });
  },
  removeTokenLijianlifu() {
    return Cookies.remove(TokenKey, { domain: shareDomainLijianlifu });

  },

};
